import React, { forwardRef, memo } from 'react';
import HBAutosizeTextAreaField, {
    HBAutosizeTextAreaFieldProps
} from '../HBAutosizeTextAreaField/HBAutosizeTextAreaField';
import useFormFieldProps, {
    FormFieldProps,
    TFormInputValidationProps,
    useFormInputValidationProps
} from './useFormFieldProps';

const HBFormAutosizeTextAreaField = forwardRef<
    HTMLTextAreaElement,
    Omit<
        FormFieldProps<HBAutosizeTextAreaFieldProps>,
        TFormInputValidationProps
    >
>((props, ref) => {
    const fieldProps = useFormFieldProps(props, true);
    const validationProps = useFormInputValidationProps(props.id);

    return (
        <HBAutosizeTextAreaField
            ref={ref}
            {...fieldProps}
            {...validationProps}
        />
    );
});

export default memo(HBFormAutosizeTextAreaField);
